function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1611 22.5334V12.231H42.2079V9.46658H55.3736V12.231H50.4042V22.5495H47.1611V22.5334Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3756 22.5334H58.1326V9.46658H61.3756V22.5334Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M69.1202 22.5334V12.231H64.1669V9.46658H77.3326V12.231H72.3632V22.5495H69.1202V22.5334Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M82.1407 9.46658H86.8036L91.7246 22.5334H88.8365C88.4493 22.5334 88.1105 22.2923 87.9814 21.9387L87.3844 20.2993H81.6889L81.1081 21.9387C80.979 22.3084 80.6402 22.5495 80.2529 22.5495H77.3649L82.1407 9.46658ZM82.6409 17.5349H86.3518L84.7061 13.0025C84.5609 12.5846 84.4963 12.0703 84.4802 11.8292C84.4641 12.0382 84.4156 12.4721 84.2704 12.9864L82.6409 17.5349Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M106.359 22.5334H102.986C102.68 22.5334 102.389 22.3727 102.212 22.1155L97.533 14.8187C97.2587 14.4008 97.178 14.0151 97.1458 13.8222V22.5334H93.9027V9.46658H97.3555C97.6621 9.46658 97.9525 9.62731 98.13 9.88446L102.744 17.1009C103.003 17.5349 103.083 17.8885 103.116 18.0653V9.46658H106.342V22.5334H106.359Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6659 32C12.6978 32 11.9073 31.2124 11.9073 30.2481V16.1045C11.9073 15.1401 12.6978 14.3526 13.6659 14.3526C14.634 14.3526 15.4246 15.1401 15.4246 16.1045V30.2481C15.4246 31.2124 14.634 32 13.6659 32Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3136 31.9518C20.3456 31.9518 19.555 31.1642 19.555 30.1999V11.1542C19.555 9.20944 21.1362 7.65042 23.0723 7.65042H33.6404C34.0922 7.65042 34.4471 8.00401 34.4471 8.45404V8.67905C34.4471 10.0452 33.3339 11.1542 31.9624 11.1542H24.831C23.8629 11.1542 23.0723 11.9417 23.0723 12.9061V30.1838C23.0723 31.1642 22.2817 31.9518 21.3136 31.9518Z",
  fill: "#7E889B"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.67968 3.50377H1.75866C0.79059 3.50377 0 2.7323 0 1.75188C0 0.787544 0.79059 0 1.75866 0H6.67968C7.64775 0 8.43834 0.787544 8.43834 1.75188C8.43834 2.7323 7.64775 3.50377 6.67968 3.50377Z",
  fill: "white"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9073 11.1707H2.48471C1.11328 11.1707 0 10.0617 0 8.6956V8.47058C0 8.02056 0.354959 7.66697 0.806725 7.66697H10.1325C11.1005 7.66697 11.8911 6.87942 11.8911 5.91508V3.52031C11.8911 1.57556 13.4723 0.0165405 15.4084 0.0165405H31.9463C33.3177 0.0165405 34.431 1.12553 34.431 2.49168V2.71669C34.431 3.16672 34.076 3.52031 33.6243 3.52031H17.1671C16.199 3.52031 15.4084 4.30785 15.4084 5.27219V7.6509C15.4246 9.59565 13.8434 11.1707 11.9073 11.1707Z",
  fill: "#067FED"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M122.913 12.2953L121.977 13.0347C121.315 11.2667 120.17 10.5435 118.169 10.5435C115.959 10.5435 114.684 11.6203 114.684 13.0347C114.684 14.3687 115.571 15.0437 118.556 15.558C121.88 16.1045 123.074 17.117 123.074 18.9975C123.074 21.0708 121.17 22.453 118.33 22.453C115.684 22.453 113.813 21.328 113.119 19.5118L114.055 18.7725C114.603 20.4922 116.152 21.4405 118.363 21.4405C120.46 21.4405 121.961 20.5887 121.961 19.0457C121.961 17.7921 121.041 17.0688 118.25 16.6027C114.765 16.008 113.571 15.0276 113.571 13.1472C113.571 11.2185 115.297 9.54697 118.185 9.54697C120.476 9.54697 122.074 10.447 122.913 12.2953Z",
  fill: "#067FED"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M127.188 22.2441H126.107V9.72375H127.188V22.2441Z",
  fill: "#067FED"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M143 22.2441H141.951V13.2597L142.064 10.7524L137.579 22.2441H136.611L132.141 10.7524H132.125L132.238 13.2597V22.2441H131.206V9.72375H132.513C132.706 9.72375 132.884 9.85233 132.964 10.0291L136.401 18.7725L137.079 20.9744H137.095L137.805 18.7886L141.225 10.0291C141.29 9.83626 141.483 9.72375 141.677 9.72375H143V22.2441Z",
  fill: "#067FED"
});

var SvgLogoSim = function SvgLogoSim(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 32,
    viewBox: "0 0 143 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoSim, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LogoSim.51a4767b.svg";
export { ForwardRef as ReactComponent };